import type { SupportedLanguage } from './storage';

/** A string written once per supported locale (long copy that lives outside the locale files). */
export type LocalizedText = Record<SupportedLanguage, string>;

export function pickLocalized(
  value: LocalizedText,
  language: SupportedLanguage
): string {
  return value[language] ?? value.en;
}
